import { useEffect, useState } from "react";
import Loader from "../../../SharedComponents/Loader/Loader";
import Styles from "./Plans.module.css";
import { plansService, selectPlanService } from "../../../Services/ApiServices";
import toast from "react-hot-toast";
import ReactPaginate from "react-paginate";
import LeftArrow from "../../../Assets/modal_left_arrow.png";
import RightArrow from "../../../Assets/modal_right_arrow.png";
import { Col, Row } from "antd";
import { Confirmation } from "../../../Modal/Confirmation";
import ImportProduct from "../Products/ImportProduct";
import { useNavigate } from "react-router-dom";
import { formatINR } from "../../../Utility/Utility";

export const Plans = () => {
  const navigation = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [plansList, setListPlans] = useState([]);
  const [page, setPage] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [showWarning, setShowWarning] = useState(false);

  const plansdata = [
    {
      description: "Basic monthly plan",
      franchise_product: 1,
      gst_percent: 18,
      kstore_product: 0,
      no_of_days: 30,
      plan_title: "Starter Plan",
      price: 199,
      subscription_id: 1,
    },
    {
      description: "Quarterly growth plan",
      franchise_product: 0,
      gst_percent: 18,
      kstore_product: 1,
      no_of_days: 90,
      plan_title: "Growth Plan",
      price: 499,
      subscription_id: 2,
    },
    {
      description: "Half-yearly premium access",
      franchise_product: 1,
      gst_percent: 18,
      kstore_product: 1,
      no_of_days: 180,
      plan_title: "Premium Plan",
      price: 899,
      subscription_id: 3,
    },
    {
      description: "Yearly business plan",
      franchise_product: 1,
      gst_percent: 28,
      kstore_product: 1,
      no_of_days: 365,
      plan_title: "Business Plan",
      price: 1499,
      subscription_id: 4,
    },
    {
      description: "Short trial plan",
      franchise_product: 0,
      gst_percent: 12,
      kstore_product: 0,
      no_of_days: 7,
      plan_title: "Trial Plan",
      price: 49,
      subscription_id: 5,
    },
    {
      description: "Ultimate enterprise package",
      franchise_product: 1,
      gst_percent: 32,
      kstore_product: 1,
      no_of_days: 730,
      plan_title: "Enterprise Plan",
      price: 2999,
      subscription_id: 6,
    },
  ];

  useEffect(() => {
    handleListPlans(1);
  }, []);

  const handleListPlans = (pageNumber = 1) => {
    setIsLoader(true);

    plansService(pageNumber, 20)
      .then((res) => {
        console.log(res?.data, "planslist");

        setListPlans({
          ...res?.data,
          items: res?.data?.items?.map((ele) => {
            return {
              ...ele,
              gst_amount: formatINR(ele?.gst_amount),
              total_price: formatINR(ele?.total_price),
              price: formatINR(ele?.price),
            };
          }),
        });
        setPage(pageNumber - 1);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleChoosePlan = (plan) => {
    console.log(plan, "plan");

    setIsLoader(true);

    let formData = new FormData();
    formData.append("subscription_id", plan?.subscription_id);

    selectPlanService(formData)
      .then((res) => {
        console.log(res?.data, "planslist");
        toast.error(res?.data?.detail?.message, { type: "success" });
        handleListPlans();
        setShowConfirmation(false);
        navigation("/store");
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  return (
    <div className={Styles.parentContainer + " container-fluid"}>
      <Loader isLoader={isLoader} />

      {showWarning ? (
        <Confirmation
          isOpen={showWarning}
          onHide={() => setShowWarning(false)}
          onSucess={() => {
            setShowWarning(false);
            handleChoosePlan(selectedPlan);
          }}
          successBtn="Choose Plan"
          content="Are you sure do you want to choose this Plan?"
          title="Confirmation"
          showContent={true}
        />
      ) : null}

      {showConfirmation ? (
        <Confirmation
          isOpen={showConfirmation}
          onHide={() => setShowConfirmation(false)}
          dataKey={[
            {
              attribute: "plan_title",
              key: "Plan",
            },
            {
              attribute: "description",
              key: "Description",
            },
            {
              attribute: "no_of_days",
              key: "Validity (Days)",
            },
            {
              attribute: "price",
              key: "Cost",
              isAmount: true,
            },
            {
              attribute: "gst_percent",
              key: "GST %",
              ispercentage: true,
            },
            {
              attribute: "gst_amount",
              key: "GST Amount",
              isAmount: true,
            },
            {
              attribute: "total_price",
              key: "Total Cost",
              isAmount: true,
            },
          ]}
          data={selectedPlan}
          onSucess={() => {
            setShowConfirmation(false);
            setShowWarning(true);
          }}
        />
      ) : null}

      <div className={Styles.childContainerParent}>
        <div className={Styles.childContainer}>
          <p
            className="fontBold align-self-center d-flex justify-content-center gap-2"
            style={{ paddingBottom: 10, fontSize: 23 }}
          >
            Choose your <span className="orange">plans</span>
          </p>

          {/* <div className={Styles.plansCotainer}> */}
          {plansList?.items?.length > 0 ? (
            <div className={Styles.plan_container}>
              {plansList?.items?.map((ele) => (
                <div className={Styles.plan_card_wrapper} key={ele.id}>
                  <div className={Styles.subPlancard}>
                    <p className={Styles.planTitle}>{ele?.plan_title}</p>

                    <div className={Styles.planAmountDays}>
                      <p className={Styles.planAmount}>
                        <span>₹</span> {ele?.price}
                      </p>
                      <p className={Styles.planDay}>{ele?.no_of_days} Days</p>
                    </div>

                    <p className={Styles.planDescription}>{ele?.description}</p>

                    <div className={Styles.choosePlanBtnContainer}>
                      <button
                        className={
                          ele?.status
                            ? Styles.disabelChoosePlanBtn
                            : Styles.choosePlanBtn
                        }
                        onClick={() => {
                          setSelectedPlan(ele);
                          setShowConfirmation(true);
                        }}
                        disabled={ele?.status}
                      >
                        Choose Plan
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            // <Row gutter={[16, 16]}>
            //   {plansList?.items?.map((ele) => (
            //     <Col
            //       key={ele.id}
            //       xxl={4} // 24 / 4 = 6, but we override to 5 using custom CSS below
            //       xl={4}
            //       lg={6}
            //       md={8}
            //       sm={12}
            //       xs={24}
            //       className="plan-col"
            //     >
            //       <div className={Styles.subPlancard}>
            //         <p className={Styles.planTitle}>{ele?.plan_title}</p>

            //         <div className={Styles.planAmountDays}>
            //           <p className={Styles.planAmount}>
            //             <span>₹</span> {ele?.price}
            //           </p>
            //           <p className={Styles.planDay}>{ele?.no_of_days} Days</p>
            //         </div>

            //         <p className={Styles.planDescription}>{ele?.description}</p>

            //         <div className={Styles.choosePlanBtnContainer}>
            //           <button
            //             className={
            //               ele?.status
            //                 ? Styles.disabelChoosePlanBtn
            //                 : Styles.choosePlanBtn
            //             }
            //             onClick={() => {
            //               setSelectedPlan(ele);
            //               setShowConfirmation(true);
            //             }}
            //             disabled={ele?.status}
            //           >
            //             Choose Plan
            //           </button>
            //         </div>
            //       </div>
            //     </Col>
            //   ))}
            // </Row>
            <div className={Styles.nodataFoundContainer}>
              <p className={Styles.noDataFoundMsg}>No Data Found</p>
            </div>
          )}

          {/* </div> */}

          <div
            style={{ display: plansList.total <= 20 ? "none" : "flex" }}
            className={Styles.paginationContainer}
          >
            <ReactPaginate
              previousLabel={<img src={LeftArrow} alt="left" />}
              nextLabel={<img src={RightArrow} alt="right" />}
              breakLabel="..."
              pageCount={Math.ceil(plansList.total) / 20}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={({ selected }) => handleListPlans(selected + 1)}
              containerClassName={"pagination m-0"}
              pageClassName={"page-item"}
              pageLinkClassName={
                "page-link text-secondary rounded-circle bg-light pt-1 pb-1 ps-2 pe-2 ms-1 me-1 border-0 shadow-none"
              }
              forcePage={page}
              previousClassName={"page-item"}
              previousLinkClassName={
                "page-link border-0 text-dark p-1 rounded-circle bg_orange shadow-none me-1"
              }
              nextClassName={"page-item "}
              nextLinkClassName={
                "page-link border-0 text-dark p-1 bg_orange rounded-circle shadow-none ms-1"
              }
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
